import React from 'react'

class Star extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
        <title>Star</title>
        <polygon className="star" points="17.5 25.76 6.68 33.29 10.5 20.68 0 12.71 13.17 12.45 17.5 0 21.83 12.45 35 12.71 24.5 20.68 28.32 33.29 17.5 25.76"/>
      </svg>
    )
  }
}

export default Star;



// WEBPACK FOOTER //
// ./src/components/rating/stars/star/index.js